import styled from 'styled-components';

export const FinancialLogsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;